module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAeElEQVQ4T2NkoBJgpJI5DCPBoP///wv8+PGrgIGB6T+x4cbBwTKRkZHxA0g9Shh9//4rgYGBYT6RBiVycrItgKnFCGwiDUMxBMNFMNMJGIZhCE6DQBI4DMNqCF6DsBiG0xCCBiEZxoAcsNgiYySkbCITIU5lgy+MAJTlJhNAJXnIAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/arrow-down.png
// module id = P3fT
// module chunks = 0